import { Toaster as SonnerToaster, type ToasterProps } from "sonner";

/**
 * V2 toast surface. Wraps Sonner with Dewey tokens — fast in/out (200ms),
 * 4s duration, top-right.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      duration={4000}
      richColors={false}
      closeButton
      toastOptions={{
        classNames: {
          toast: "group rounded-[var(--radius-md)] border border-border-default bg-bg-surface text-fg-1 shadow-md",
          description: "text-fg-2 text-[12px]",
          actionButton: "bg-[var(--btn-primary-bg)] text-white",
          cancelButton: "bg-bg-subtle text-fg-2",
          error: "border-[var(--danger)]/40",
          success: "border-[var(--success)]/40",
          warning: "border-[var(--warning)]/40",
          info: "border-primary-300",
        },
      }}
      {...props}
    />
  );
}
